import { useDeleteExerciseMutation } from '@src/api/api-hooks/exercises/useDeleteExerciseMutation.ts';
import { useAppDispatch } from 'library/hooks/common';
import { openDialogModal, showPopup } from 'library/redux/modal';

type PT = {
  videoId: number;
  onBeforeRemove?: (id: number) => void;
  onSuccess?: (id: number) => void;
};
export const useRemoveExercise = ({ onBeforeRemove, onSuccess, videoId }: PT) => {
  const dispatch = useAppDispatch();

  const { mutateAsync: removeExerciseMutation } = useDeleteExerciseMutation();
  const removeVideo = async () => {
    let message = '';
    let messageType: 'success' | 'error' = 'success';

    onBeforeRemove && onBeforeRemove(videoId);
    await removeExerciseMutation(
      { id: String(videoId) },
      {
        onError: (error) => {
          console.error(error);
          messageType = 'error';
          message = `Не удалось удалить видео`;
        },
        onSuccess: () => {
          onSuccess && onSuccess(videoId);
          message = 'Видео успешно удалено';
        },
      }
    );

    dispatch(showPopup({ type: messageType, text: message }));
  };

  const beginRemoveDialog = () => {
    dispatch(
      openDialogModal({
        title: 'Удаление видео',
        text: 'Вы действительно хотите удалить видео?',
        confirmText: 'Удалить',
        confirm: () => removeVideo(),
        declineText: 'Оставить',
      })
    );
  };

  return {
    removeExercise: beginRemoveDialog,
  };
};
